module.exports = __webpack_public_path__ + "img/upload.c8dd1bc8.svg";